/*
 * @Author: huangzq
 * @Date: 2019-09-27 17:28:26
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-11-19 14:56:25
 * @Desc: 无限滚动组件
*/
<template>
  <div
    v-infinite-scroll="scrollLoadFun"
    :infinite-scroll-disabled="scrollDisabled"
    :infinite-scroll-distance="scrollDistance"
    class="infinite-scroll"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'InfiniteScroll',
  props: {
    // * api接口数据
    api: {
      type: Object,
      default () {
        return {
          // 接口方法：必须为Promise对象
          promiseFun: '',
          params: {}
        }
      }
    },
    // * 每页条数
    pageSize: {
      type: [String, Number],
      default: 10
    },
    // * 触发加载的距离阈值，单位为px
    scrollDistance: {
      type: Number,
      default: 100
    },

    // this.$loading方法里面的target参数值
    loadingTarget: {
      type: String,
      default: '.infinite-scroll-wrapper'
    }
  },
  data () {
    return {
      // * 接口分页参数
      pageParam: {
        page: 0,
        pageSize: this.pageSize
      },

      // * 是否正在加载数据
      loading: false,

      // * 是否没有更多数据了，初始为：false（这样一进入页面就通过scrollLoadFun去拉取数据，可以不用created生命周期了）
      noMore: false,

      searchParams: {},
      myLoading: ''
    }
  },

  computed: {
    /**
     * * 当为true，滚动时将不再拉取数据
     * * 正在加载请求数据时，为true
     * * 没有更多数据时，为true
     */
    scrollDisabled () {
      const scrollDisabled = this.loading || this.noMore
      return scrollDisabled
    }
  },
  methods: {
    // * 重置页数方法：page=1；并重新拉取数据
    resetPage (searchParams) {
      this.loading = true
      this.pageParam.page = 1
      this.searchParams = searchParams
      this.getData()
    },

    // * 滚动时，触发的事件
    scrollLoadFun () {
      this.loading = true
      this.pageParam.page++
      this.getData()
    },

    /**
     * * 通过接口获取数据列表
     */
    async getData () {
      this.myLoading = this.$loading({
        target: this.loadingTarget,
        customClass: 'infinite-scroll-loading'
      })
      const { promiseFun, params } = this.api
      if (typeof promiseFun === 'function') {
        const res = await promiseFun({
          ...params,
          ...this.pageParam,
          ...this.searchParams
        })
        if (res.success) {
          const list = res.data.data || []
          // * 当数据列表长度小于每页条数时，表明没有更多数据了
          this.noMore = list.length < this.pageParam.pageSize
          this.$emit('on-load-over', list)
          // 返回列表数据+其他接口返回值
          this.$emit('on-load-over-res', { list, res })
        }
        this.$nextTick(() => {
          setTimeout(() => {
            this.myLoading.close()
            this.loading = false
          }, 10)
        })
      }
    }
  }
}
</script>
